export default "__VITE_ASSET__C6ie239v__"